// CRA only includes env vars with REACT_APP_ prefix in production bundles.
export const BASE_URL =
  process.env.REACT_APP_BACKEND_API_URL ||
  "https://dev-api.erchonia.com/api/v1";

export const routes = {
  // -----AUTH------//
  signUp: BASE_URL + "/user/signup",
  signIn: BASE_URL + "/user/login",
  logOut: BASE_URL + "/user/logout",
  createAdmin: BASE_URL + "/user/add-admin",
  getAllAdmin: BASE_URL + "/user",
  userDelete: BASE_URL + "/user",
  sendNotification: BASE_URL + "/user/send-notifications",
  fileUpload: BASE_URL + "/user/upload-file",
  imageUpload: BASE_URL + "/user/upload",
  getAllCustomer: BASE_URL + "/user/customer",

  // -----------Faq--------------//
  getAllFaq: BASE_URL + "/faq",
  createFaq: BASE_URL + "/faq/create",
  // -------------Services-------------//

  // -------------Services-------------//
};
